/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteGcpIamCredentialSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteGcpIamCredentialRequest = {
  /**
   * The ID of the credential to delete.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DeleteGcpIamCredentialSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteGcpIamCredentialSecurity$outboundSchema: z.ZodMiniType<
  DeleteGcpIamCredentialSecurity$Outbound,
  DeleteGcpIamCredentialSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteGcpIamCredentialSecurityToJSON(
  deleteGcpIamCredentialSecurity: DeleteGcpIamCredentialSecurity,
): string {
  return JSON.stringify(
    DeleteGcpIamCredentialSecurity$outboundSchema.parse(
      deleteGcpIamCredentialSecurity,
    ),
  );
}

/** @internal */
export type DeleteGcpIamCredentialRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteGcpIamCredentialRequest$outboundSchema: z.ZodMiniType<
  DeleteGcpIamCredentialRequest$Outbound,
  DeleteGcpIamCredentialRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function deleteGcpIamCredentialRequestToJSON(
  deleteGcpIamCredentialRequest: DeleteGcpIamCredentialRequest,
): string {
  return JSON.stringify(
    DeleteGcpIamCredentialRequest$outboundSchema.parse(
      deleteGcpIamCredentialRequest,
    ),
  );
}
